import React from "react";
import { cardCls, labelCls } from "./tokens";

/**
 * TimelineCard — activity log entry.
 * Variants:
 *   - action: standard action line ("created the sale")
 *   - change: before → after state change
 *   - note: free-form comment
 */
export default function TimelineCard({
  actor,
  action,
  before,
  after,
  note,
  department,
  timestamp,
  Icon,
  variant = "action",
  testId,
}) {
  return (
    <div
      data-testid={testId || `timeline-item-${(action || "x").toLowerCase().replace(/\s+/g, "-")}`}
      className={`${cardCls} flex gap-4 p-4`}
    >
      {/* Avatar / Icon column */}
      <div className="flex flex-col items-center gap-2 shrink-0">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-onedesk-bg border border-onedesk-border">
          {Icon ? (
            <Icon className="h-4 w-4 text-onedesk-primary" strokeWidth={2.25} />
          ) : (
            <span className="text-xs font-bold text-onedesk-primary">
              {(actor || "?").slice(0, 1).toUpperCase()}
            </span>
          )}
        </span>
      </div>

      {/* Content */}
      <div className="flex flex-col gap-2 min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <span className="font-bold text-sm text-onedesk-textPrimary">
            {actor || "System"}
          </span>
          <span className="font-medium text-sm text-onedesk-textSecondary">
            {action}
          </span>
          {department && (
            <span className="inline-flex items-center rounded-od-input bg-onedesk-bg px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-onedesk-textSecondary border border-onedesk-border">
              {department}
            </span>
          )}
        </div>

        {variant === "change" && (before || after) && (
          <div className="flex flex-wrap items-center gap-2 text-xs">
            {before && (
              <span className="line-through font-medium text-onedesk-textSecondary">
                {before}
              </span>
            )}
            <span className="text-onedesk-textSecondary">→</span>
            <span className="rounded-od-input bg-onedesk-success/10 text-onedesk-success border border-onedesk-success/20 px-2 py-0.5 font-bold">
              {after}
            </span>
          </div>
        )}

        {variant === "note" && note && (
          <p className="font-medium text-sm text-onedesk-textPrimary leading-relaxed bg-onedesk-bg border border-onedesk-border rounded-od-input px-3 py-2">
            {note}
          </p>
        )}

        {timestamp && (
          <span className={labelCls}>{timestamp}</span>
        )}
      </div>
    </div>
  );
}
